import { useTranslation } from 'react-i18next';
import { Box, type BoxProps, Typography, styled } from '@mui/material';
import {
  WithTheme,
  useAtlasCoreThemeTokens,
} from '@issuemanager/apps/client/theme';
import { ChevronDown } from '../../icons';

const StyledDropdownLike = styled(Box)<WithTheme<BoxProps>>(({ theme }) => ({
  display: 'flex',
  height: 40,
  alignItems: 'center',
  borderRadius: 4,
  borderColor: theme.tokens.core.color.legacy.medium.value,
  borderWidth: 1,
  borderStyle: 'solid',
  background: theme.tokens.semantic.color.background.container.value,
  width: '100%',
}));

const StyledBox = styled(Box)`
  width: fit-content;
  display: flex;
  justify-content: flex-end;
  padding-right: ${({ theme }) => theme.spacing(2)};
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};
  flex: 1 0 0;
  & svg {
    display: flex;
    height: 24px;
    width: 24px;
    justify-content: center;
    align-items: center;
  }
`;

export function FakeDropdownBox(props: BoxProps) {
  const { t } = useTranslation('common');
  const { children, ...rest } = props;
  const core = useAtlasCoreThemeTokens();

  return (
    <StyledDropdownLike {...rest}>
      <Typography px={2} py={0} noWrap>
        {children ?? t('filters.dropdownDefault')}
      </Typography>
      <StyledBox>
        <ChevronDown active activeColor={core.color.legacy.blackNear.value} />
      </StyledBox>
    </StyledDropdownLike>
  );
}
